import { http } from '@/api/http';
import { getGeoApiUrl } from './geo.paths';
import { CountryRegistryView } from './geo.types';

const getGeoLibrary = async () => {
  const res = await http.get<CountryRegistryView>(getGeoApiUrl.registry());
  return res.data;
};

export const geoApiFetcher = {
  getGeoLibrary,
};
